{
  "fr": {
    "installment_term": {
      "actions": {
        "addUnits": "Unités",
        "add_fraction": "Ajouter une fraction",
        "create": "Créer",
        "create_price_term": "nouvelle règle",
        "delete": "Supprimer",
        "deleteMultiple": "Supprimer...",
        "delete_cancel": "Annuler",
        "edit": "Modifier",
        "newInstallment": "Paiement partiel",
        "publish_customer": "Publier pour le client",
        "selectAll": "Sélectionner toutes les {total} paiements partiels",
        "selectOne": "Sélectionnez au moins 1 paiement partiel",
        "take": "Prendre"
      },
      "attributes": {
        "description": "Description",
        "installments_count": "{count} paiement partiel | {count} paiements partiels",
        "name": "Titre"
      },
      "labels": {
        "addAllSurcharges": "Tous les suppléments actuels",
        "addAllUnitsPrices": "Tous prix des unités",
        "allUnitsAssigned": "Toutes les unités assignées",
        "amount": "Montant",
        "balanceFractionTypes": "Types de fractions d'équilibre",
        "balanceTotal": "Solde total",
        "containsSurcharges": "Contient des suppléments",
        "create_decision_first": "Cette option sera disponible une fois que vous aurez créé une décision.",
        "deleteInstallmentTerm": "Supprimer paiement partiel",
        "description": "Description",
        "documents": "Documents",
        "duplicate_price_type": "Une fraction avec ce type de prix existe déjà.",
        "editInstallmentTerm": "Modifier paiement partiel",
        "edit_description": "Éditer la description",
        "fixed": "Résolu",
        "fixedAmount": "Montant fixe de",
        "for": "pour",
        "forEachUnit": "de chaque unité",
        "fraction_types": {
          "absolute": "Montant fixe",
          "relative": "Pourcentage"
        },
        "goToAmounts": "Sélectionner les montants",
        "installments": "Finances",
        "installmentsTitle": "Paiement partiel",
        "installments_all_projects": "Finances de tous les projets",
        "invalidAmount": "Montant invalide",
        "list": "Liste",
        "name": "Paiement partiel #{count}",
        "noContainsSurcharges": "Ne contient pas de suppléments",
        "noInstallmentsToPay": "Pas de paiments partiel pour le moment",
        "noUnitsClick": "Pas encore d'unités pour ce projet, cliquez ici pour ajouter",
        "ofThe": "du",
        "price_types": {
          "custom_amount": "Autre",
          "price_value": "Valeur totale",
          "price_value_construction": "Valeur de construction",
          "price_value_construction_existing": "Coûts de la construction existante",
          "price_value_fees": "Honoraires d'architecte/d'ingénierie",
          "price_value_land": "La valeur due terrain",
          "surcharge": "Supplements",
          "unit": "Prix des unités"
        },
        "projectUnitsTotal": "{project_name} a {units_count_max} unités au total",
        "publish_now": "Publier maintenant?",
        "rules": "Règles de paiement",
        "rules_subtitle": "Définissez le pourcentage ou le montant à collecter",
        "save_explainer": "Rendre ce terme de versement visible pour vos clients ? Ou enregistrer et publier plus tard ?",
        "selectUnits": "Sélectionnez les unités",
        "selected": "{selected} paiement partiel sélectionnée. | {selected} paiements partiels sélectionnées.",
        "shortcuts": "Raccourcis",
        "show_installment_terms_for": "Afficher les paiements partiels pour",
        "step1Info": "Ajouter une description",
        "step2Subtitle": "Sélectionnez votre projet pour inclure toutes vos unités à la fois.",
        "step2Title": "Quelles unités sont liées à ce paiement?",
        "surcharges": "Supplements",
        "total": "Total",
        "totalFixed": "Total fixé",
        "totalPaid": "Total payé",
        "totalRequested": "Total facturé",
        "totalSelected": "Toutes les {total} paiements partiels sont sélectionnées.",
        "totalSurcharges": "Total surtaxé",
        "totalUnpaid": "Total impayé",
        "unitSelected": "Pas d'unité | 1 unité | {count} unités",
        "units": "Unités"
      },
      "navigation": {
        "backToInstallmentTerms": "Retour à l'aperçu"
      },
      "placeholders": {
        "amount": "Choisir un montant fixe ou un pourcentage de la valeur unitaire ou les surcharges",
        "description": "Par exemple. 10% - Après avoir affaibli la dalle de béton du premier étage ...",
        "due_date": "Fixez une date à laquelle l'acompte doit être payé",
        "employees": {
          "new": {
            "subtitle": "Ajouter des versements et suivre leur statut",
            "title": "Créer un aperçu financier"
          }
        },
        "installmentTermFractionNotice": "Les montants des versements ne peuvent plus être ajustés car certains versements ont déjà été livrés à l'acheteur",
        "name": "Par example Versement #1, Versement - Supplements",
        "summary": "Sommaire",
        "surcharge": "supplement"
      },
      "toasts": {
        "bulk_create": "Le versement creé avec succès | Les versements creé avec succès",
        "bulk_delete": "Le versement supprimé avec succès | Les versements ont été supprimés avec succès",
        "bulk_update": "Le versement a été mis à jour avec succès | Les versements ont été mis à jour avec succès",
        "delete": "Versement supprimé avec succès",
        "update": "Versement mis à jour avec succès"
      },
      "validation": {
        "fixedFractionLabel": "{price_type} a déjà été combiné avec {fraction_type} dans un autre paiement partiel existant. Seul {fraction_type} est autorisé à conserver la cohérence.",
        "maxLengthName": "Le nom est trop long",
        "needDescription": "Description obligatoire",
        "needInstallmentTermFraction": "Un terme de prix est requis",
        "needName": "Nom obligatoire",
        "needUniquePricesTypes": "Les règles ne peuvent pas avoir le même type de prix dans une versement",
        "needValidTerm": "Le montant ne peut pas être 0 et le type de prix doit exister",
        "selectInstallmentTerm": "Sélectionnez au moins 1 versement",
        "selectUnit": "Sélectionner au moins 1 unité"
      }
    }
  }
}
